import { useDynamicData } from '@avensia/excite';
import * as React from 'react';
import { WishlistUpdateCommand, wishlistUpdateEvent } from '@avensia/excite-commercetools';
import { addToDataLayer, type DataLayerEvent, type EcommerceAdditionAttributes } from '..';
import { cartToDataLayerInfo, convertProductToGA4 } from '../utils';

export function useWishlistTracking() {
  const [wishlist] = useDynamicData<Excite.Commercetools.WishlistApiModel>();
  const previousWishlist = React.useRef(wishlist);

  React.useEffect(
    () =>
      wishlistUpdateEvent.on(async event => {
        if (event.command === WishlistUpdateCommand.Add) {
          const product = event.wishList?.items.find(t => t.code === event.requestData.sku)?.trackingProductInformation;
          if (product) {
            const ga4Event: DataLayerEvent = {
              event: 'add_to_wishlist',
              ...((event.commandEventData?.additionalProductAttributes as EcommerceAdditionAttributes)?.ecommerce ??
                {}),
              ...(await cartToDataLayerInfo()),
              ecommerce: {
                items: [
                  {
                    ...convertProductToGA4(product),
                    quantity: 1,
                  },
                ],
              },
            };
            addToDataLayer(ga4Event);
          }
        }

        if (event.command === WishlistUpdateCommand.Remove) {
          const product = previousWishlist.current?.items?.find(
            x => x.code === event.requestData.sku,
          )?.trackingProductInformation;

          if (product) {
            const ga4Event: DataLayerEvent = {
              event: 'remove_from_wishlist',
              ecommerce: {
                ...((event.commandEventData?.additionalProductAttributes as EcommerceAdditionAttributes)?.ecommerce ??
                  {}),
                ...(await cartToDataLayerInfo()),
                items: [
                  {
                    ...convertProductToGA4(product),
                    quantity: 1,
                  },
                ],
              },
            };
            addToDataLayer(ga4Event);
          }
        }
        previousWishlist.current = event.wishList;
      }),
    [],
  );
}
